'use strict';

const pageLink = window.location.href;
const pageTitle = encodeURIComponent(document.title);

/**
 * Set events on social network buttons
 *
 */
function initEvents() {
    $('.js-fb-social-network').on('click', () => {
        window.open(`http://www.facebook.com/sharer.php?u=${pageLink}&text=${pageTitle}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
        return false;
    });
    $('.js-tw-social-network').on('click', () => {
        window.open(`https://twitter.com/intent/tweet?url=${pageLink}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
        return false;
    });
    $('.js-pt-social-network').on('click', () => {
        window.open(`https://www.pinterest.com/pin/create/button/?&text=${pageTitle}&url=${pageLink}&description=${pageTitle}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
        return false;
    });
}

module.exports = {
    initEvents: initEvents
};
